/**
 * Format currency values to avoid floating-point precision issues
 * @param {number|string} value - The value to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (value, decimals = 2) => {
  const num = parseFloat(value);
  
  if (isNaN(num)) {
    return '0.00';
  }
  
  return num.toFixed(decimals);
};

/**
 * Format currency with rupee symbol
 * @param {number|string} value - The value to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted currency string with ₹ symbol
 */
export const formatRupees = (value, decimals = 2) => {
  return `₹${formatCurrency(value, decimals)}`;
};

/**
 * Format currency with Indian number system (lakhs, crores)
 * @param {number|string} value - The value to format
 * @returns {string} Formatted currency string
 */
export const formatIndianCurrency = (value) => {
  const num = parseFloat(value);
  
  if (isNaN(num)) {
    return '₹0.00';
  }
  
  // Round to 2 decimal places first to avoid precision issues
  const rounded = Math.round(num * 100) / 100;
  
  return `₹${rounded.toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
};
